import React from 'react'
import { useState } from 'react';

import Header from "./Components/Header"
import Presentation from "./Components/Presentation"
import Timeline2 from "./Components/Timeline2"  
import AboutMe from "./Components/AboutMe" 
import ContactMe from "./Components/ContactMe"  
import MyCertifications from "./Components/MyCertifications" 

import './App.css';

const App = () => {

  const [language, setLanguage] = useState ("English")
  //console.log("idioma desde la app " + language);

  const aboutMe = (e) => {
    e.preventDefault();
    //console.log("click in aboutMe está haciendo algo");
    document.getElementById("TimeLine").className = ("hidden");
    document.getElementById("AboutMe").className = ("visible");
    document.getElementById("Certif").className = ("hidden");
    document.getElementById("Contact").className = ("hidden") 
  };

  const closeAboutMe = (e) => {
    e.preventDefault();
    //console.log("click in closeAaboutMe está haciendo algo");
    document.getElementById("TimeLine").className = ("visible");
    document.getElementById("AboutMe").className = ("hidden");
  };

  const contactMe = (e) => {
    e.preventDefault();
    //console.log("click in ContactMe está haciendo algo");
    document.getElementById("TimeLine").className = ("hidden");
    document.getElementById("AboutMe").className = ("hidden");
    document.getElementById("Certif").className = ("hidden");
    document.getElementById("Contact").className = ("visible");
  };

  const closeContactMe = (e) => {
    e.preventDefault();
    //console.log("click in closeContactMe está haciendo algo");
    document.getElementById("TimeLine").className = ("visible");
    document.getElementById("Contact").className = ("hidden");  
  };

  const certif = (e) => {
    e.preventDefault();
    console.log("click in Certif está haciendo algo");
    document.getElementById("TimeLine").className = ("hidden");
    document.getElementById("AboutMe").className = ("hidden");
    document.getElementById("Certif").className = ("visible");
    document.getElementById("Contact").className = ("hidden");
  };

  const closeCertif = (e) => {
    e.preventDefault();
    //console.log("click in closeContactMe está haciendo algo");
    document.getElementById("TimeLine").className = ("visible");
    document.getElementById("Certif").className = ("hidden");   
  };


    return (
      <div className="App">
        <Header 
          language={language}
          setLanguage={setLanguage}
        />
        <div className="MainContainer">
          <Presentation 
            language={language} 
            aboutMe={aboutMe}
            certif={certif}
            contactMe={contactMe}
          /> 

          <div id="TimeLine">
            <Timeline2 
            language={language}
            style={{ display: "block"}}
            closeAboutMe={closeAboutMe}
            closeContactMe={closeContactMe}
            />
          </div>
          <div id="AboutMe" className='hidden'>
            <AboutMe 
            language={language}
            closeAboutMe={closeAboutMe}
            />
          </div>
          <div id="Certif" className='hidden'>
            <MyCertifications 
            language={language}
            closeCertif={closeCertif}
            />
          </div>
          <div id="Contact" className='hidden'>
            <ContactMe 
            closeContactMe={closeContactMe}
            />
          </div>
        </div>
      </div>
  );
}
  


export default App;
